const initDOM = () => {
    Promise.all([
        import(/* webpackChunkName: "jQuery" */ 'jquery'),
        import(/* webpackChunkName: "bootstrap" */ 'bootstrap'),
    ]).then(([{ default: $ }]) => {
        $('body').removeClass('preload');
    });
};

// import(/* webpackChunkName: "Banner" */ 'dom/banner').then((Banner) => Banner.binds());
import(/* webpackChunkName: "Banner" */ 'dom/modal-slider').then((ModalSlider) => ModalSlider.binds());
import(/* webpackChunkName: "Field" */ 'dom/field').then((Field) => Field.binds());
import(/* webpackChunkName: "Field" */ 'dom/field-collapse').then((FieldCollapse) => FieldCollapse.binds());
// import(/* webpackChunkName: "FieldAddress" */ 'dom/field--address').then((FieldAddress) => FieldAddress.binds());
import(/* webpackChunkName: "FieldAddressPrefill" */ 'dom/field--addressPrefill').then((FieldAddressPrefill) => FieldAddressPrefill.binds());
import(/* webpackChunkName: "Form" */ 'dom/form').then((Form) => Form.binds());
// import(/* webpackChunkName: "Googlemap" */ 'dom/googlemap').then((Googlemap) => Googlemap.binds());
// // import(/* webpackChunkName: "Loading" */ 'dom/loading').then((Loading) => Loading.binds());
// // import(/* webpackChunkName: "Login" */ 'dom/login').then((Login) => Login.binds());
// import(/* webpackChunkName: "Menu" */ 'dom/menu').then((Menu) => Menu.binds());
import(/* webpackChunkName: "Modal" */ 'dom/modal').then((Modal) => Modal.binds());
// import(/* webpackChunkName: "ProductsGallery" */ 'dom/products-gallery').then((ProductsGallery) => ProductsGallery.binds());
// import(/* webpackChunkName: "Products" */ 'dom/products').then((Products) => Products.binds());
// // import(/* webpackChunkName: "Sections" */ 'dom/sections').then((Sections) => Sections.binds());
// import(/* webpackChunkName: "Sidebar" */ 'dom/sidebar').then((Sidebar) => Sidebar.binds());
// import(/* webpackChunkName: "Slider" */ 'dom/slider').then((Slider) => Slider.binds());
// import(/* webpackChunkName: "Window" */ 'dom/window').then((Window) => Window.binds());
import(/* webpackChunkName: "Cart" */ 'dom/cart').then((Cart) => Cart.binds());
import(/* webpackChunkName: "ExitModal" */ 'dom/exitModal').then((ExitModal) => ExitModal.binds());
import(/* webpackChunkName: "Eway" */ 'dom/eway').then((Eway) => Eway.binds());
import(/* webpackChunkName: "SegmentTracking" */ 'dom/segment-tracking').then((SegmentTracking) => SegmentTracking.binds());

initDOM();
